import { render } from "./MakeDeposit.vue?vue&type=template&id=39942246"
import script from "./MakeDeposit.vue?vue&type=script&lang=js"
export * from "./MakeDeposit.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__